module.exports = __webpack_public_path__ + "img/delete-gray-icon.9a0e253f.svg";